import { truncateString } from "@/utils/functions/functions";

interface Props {
  name: string;
  isEvent?: boolean;
}

const ProductName: React.FC<Props> = ({ name, isEvent }) => {
  return (
    <div className={`product-name ${isEvent ? "" : "event"}`} dir="auto">
      {truncateString(name, 190)}
    </div>
  );
};

export default ProductName;
